import * as _ from 'lodash';
import { Modal } from 'react-bootstrap';

import { window } from '../../../../globals';
import Button from '../../../generic/Button/Button';
import ButtonGroup from '../../../generic/Button/ButtonGroup';
import Link from '../../../generic/Link/Link';

const LoginLink = ({ loginSubdomain }: { loginSubdomain?: string }) => (
  <Link to={loginSubdomain || window.location.origin} openInNewTab>
    {loginSubdomain ? new URL(loginSubdomain).host : window.location.host}
  </Link>
);

type ModalPromptClaimDomainProps = {
  isOpen: boolean;
  loginSubdomain?: string;
  onSaveChanges(): void;
  onConfigureDomain(): void;
};

const ModalPromptClaimDomain = (props: ModalPromptClaimDomainProps) => (
  <Modal show={props.isOpen} onHide={_.noop}>
    <Modal.Header>
      <Modal.Title>Save without Email Redirection?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="margin-bottom-md">
        Are you sure you’d like to save these SSO changes without redirecting email domains?
      </p>
      <div className="gray-box">
        <p className="nomargin">
          <span className="bold">Note:</span> Without email redirection, users looking to sign in or sign up using SSO
          will need to visit <LoginLink loginSubdomain={props.loginSubdomain} /> directly.
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button type="secondary" onClick={props.onSaveChanges}>Save Changes</Button>
        <Button onClick={props.onConfigureDomain}>Configure Email Redirection</Button>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
);

export default ModalPromptClaimDomain;
